import List from "@/components/list";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete({ row }) {
    Bus.$emit("deleteHot", row);
  }
  // 编辑
  function handleUpdate({ row }) {
    Bus.$emit("updateHot", row);
  }
  function upLine({ row }) {
    Bus.$emit("upLine", row);
  }
  function downLine({ row }) {
    Bus.$emit("downLine", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "hotSearch:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "hotSearch:delete"]
    ];
    if (vo.row.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => downLine(vo),
        "hotSearch:online"
      ]);
    } else {
      dealConf.push(["icon-up", "上线", () => upLine(vo), "hotSearch:online"]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "热搜词",
      prop: "keyWords",
      minWidth: "140",
      showOverflowTooltip: true
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "创建人",
      prop: "createUserName",
      minWidth: "140",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
